import { useAjadi } from "./Context/AjadiContext";
import { useNavigate  } from "react-router-dom";
import { BaseRetorikConfig } from "./Bot/data";

import '../styles/HomePage.scss'
import { useState } from "react";
import { UpdateActivityCounter } from "../Utils/botUtils";
import { getOldUserForms } from "../Utils/globalUtils";

const HomePage = () : JSX.Element=> {
    const Ajadi = useAjadi();
    let navigate = useNavigate();
    const [values, setValues] = useState({
        firstName: '',
        name: '',
        company:'',
        mail: '',
        gdpr:false
    });

    //Handle old test date
    let oldTestDate : Date | undefined = undefined;
    if(localStorage.getItem("dateStart")){
        oldTestDate = new Date(JSON.parse(localStorage.getItem("dateStart")!));
    }

    const StartNewConversation = async (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        Ajadi.setShowBot(true);
        let userName = BaseRetorikConfig.userData.name;
        userName = `${values.name}-${values.firstName}`;
        localStorage.setItem("username",userName);
        
        //Try get history
        let jsonUserHistory = await getOldUserForms(userName)
        console.log("jsonUserHistory", jsonUserHistory)
        if(jsonUserHistory && Object.keys(jsonUserHistory).length > 0){
            let data = jsonUserHistory[Object.keys(jsonUserHistory)[0]]
            if(data && data.User){
                localStorage.setItem("retreiveHistory", JSON.stringify(true));
                localStorage.setItem("dataToRetreive", JSON.stringify(data.User));
            }
        }
        else{
            localStorage.setItem("retreiveHistory", JSON.stringify(false));
            localStorage.removeItem("dataToRetreive");
        }


        let dateStart = new Date();
        localStorage.setItem("dateStart",JSON.stringify(dateStart));
        UpdateActivityCounter("reset");
        Ajadi.setTestMode(true);
       
        BaseRetorikConfig.userData.nom = values.name;
        BaseRetorikConfig.userData.prenom = values.firstName;
        BaseRetorikConfig.userData.username = userName;
        BaseRetorikConfig.userData.name = userName;
        BaseRetorikConfig.userData.mail = values.mail;
        BaseRetorikConfig.userData.company = values.company;
      
        navigate("/ajadi");
    }


    const Export = () => {
        navigate("/export");
    }

    const handleNameInputChange = (event : React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setValues((values) => ({
            ...values,
            name: event.target.value,
        }));
    };
    
    const handleFirstNameInputChange = (event : React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setValues((values) => ({
            ...values,
            firstName: event.target.value,
        }));
    };
    const handleCompanyNameInputChange = (event : React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setValues((values) => ({
            ...values,
            company: event.target.value,
        }));
    };
    const handleMailInputChange = (event : React.ChangeEvent<HTMLInputElement>) => {
        event.persist();
        setValues((values) => ({
            ...values,
            mail: event.target.value,
        }));
    };

    const handleGdprInputChange = (event : React.ChangeEvent<HTMLInputElement>) => {
        console.log(event.target.value)
        event.persist();
        setValues((values) => ({
            ...values,
            gdpr: event.target.value === 'on' && !values.gdpr,
        }));
    };

    return (
        <main className="HomePage">
            <div className="HomeContainer">
                <h1>1ère connexion coaché</h1>
                <form onSubmit={(e) => StartNewConversation(e)}>
                    <div className="inputContainer"><label htmlFor="nom" >Nom : </label><input type="text" name="nom" required value={values.name} onChange={handleNameInputChange}/></div>
                    <div className="inputContainer"><label htmlFor="prenom" >Prenom : </label><input type="text" name="prenom" required  value={values.firstName} onChange={handleFirstNameInputChange}/></div>
                    <div className="inputContainer"><label htmlFor="company" >Société : </label><input type="text" name="company"   value={values.company} onChange={handleCompanyNameInputChange}/></div>
                    <div className="inputContainer"><label htmlFor="mail" >Email : </label><input type="email" name="mail"   value={values.mail} onChange={handleMailInputChange}/></div>
                    <div className="inputContainer"><label htmlFor="gdpr" >Acceptation RGPD : </label><input type="checkbox" name="gdpr" required checked={values.gdpr} onChange={handleGdprInputChange}/></div>
                    <button type="submit">Commencer une nouvelle session</button>
                </form>
                <button onClick={Export}>Exporter les données</button>
            </div>
        </main>
    )
}

export default HomePage